import React from 'react';
import classNames from 'classnames';
import Header, { User } from './header';

export interface LayoutProps {
  user: User;
  children?: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children, user }) => (
  <div className='max-h-screen px-3 pb-12 mx-auto md:px-12 max-w-7xl'>
    <Header user={user} />
    <div className='flex'>{children}</div>
    <style global jsx>{`
      html {
        background-color: #f4f5fa;
      }
    `}</style>
  </div>
);

export const Content: React.FC<{ className?: string; children?: React.ReactNode }> = ({ className, children }) => (
  <div className={classNames('flex-grow w-0', className)}>{children}</div>
);

export const Sider = ({ children }) => (
  <div className='flex-none ml-4 w-[284px] hidden sider:block'>
    <div className='fixed top-16 w-[284px]'>{children}</div>
  </div>
);

export default Layout;
